import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { PlanMetadata } from '@aibees/shared/features/price-and-plan/hooks/types';

export function usePlanFeatures(): PlanMetadata[] {
  const { data } = useCurrentSubscriptionApi();

  const isCurrentPlanFree = !!data?.current?.plan?.metadata.is_free;

  return [
    {
      text: 'Unused Credit Rollover',
      enable: !isCurrentPlanFree,
      description: '',
    },
    {
      text: isCurrentPlanFree
        ? 'Select up to 25 Records at a time'
        : 'Select up to 10,000 Records at a time',
      enable: true,
      description: '',
    },
    {
      text: isCurrentPlanFree
        ? 'View First 25 Filter Results'
        : 'View Unlimited Filter Results',
      enable: true,
      description: '',
    },
  ];
}
